import React, { Component } from 'react';
import Adroll from './Adroll';
import PropTypes from 'prop-types';

export default class AdrollWrapper extends Component {
    render() {
        return(
            <div>
                <Adroll config={this.props.config} reportEvent={this.props.reportEvent}/>
            </div>
        );
    }
}

AdrollWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
